import { useEffect } from "react";
import { Prompt } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CheckChangesWithoutSaving = ({ isDisabledInputs }) => {
  const [t] = useTranslation("global");

  useEffect(() => {
    const alertLeavePrescriptionsWithoutSaving = (e) => {
      e.preventDefault();
      e.returnValue = t("prescriptions_beforeLeavingMessage");
    };

    if (!isDisabledInputs) {
      window.addEventListener("beforeunload", alertLeavePrescriptionsWithoutSaving);
      return () => {
        window.removeEventListener("beforeunload", alertLeavePrescriptionsWithoutSaving);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDisabledInputs]);

  return <Prompt when={!isDisabledInputs} message={t("prescriptions_beforeLeavingMessage")} />;
};

export default CheckChangesWithoutSaving;
